import { branch } from '../../../Constants/branchUrls';
import { images } from '../../../Constants/ImageUrls';

export const returnRefundFaqData = [
  {
    question: 'How can I talk to Mylo customer care?',
    answer:
      'You can connect with Mylo customer care on this number - 08047190745.',
  },
  {
    question: 'Is Mylo customer service available 24x7?',
    answer:
      'Our business hours are from 9:00 am - 8:00 pm, Monday - Saturday. 12:00 pm - 6:00 pm for calls on Sunday & 12:00 pm - 8:00 pm for chat on Sunday.',
  },
  {
    question: 'How can I return products on Mylo?',
    answer:
      'You can raise a return request from the app/website. Alternatively, you can also reach out to us via chat/call/mail for the same.',
  },
  {
    question: 'Will I get a refund if I cancel My Mylo order?',
    answer: 'Yes, you will.',
  },
  {
    question: 'Is the bill required for returning a product on Mylo? ',
    answer:
      "The original product cover/packaging, label is enough to return the product if it's under return policy. Although the bill is not required as you can get it from the website but still it's better if you have it.",
  },
  {
    question: 'Can I cancel my order after it has been shipped?',
    answer: 'Cancellation is not possible once the order is shipped.',
  },
];

export const staticParentingData = [
  {
    itemId: 757,
    itemName: 'Store Web Top Banners',
    itemSize: 'LARGE',
    itemType: 'MULTIPLE_ITEMS',
    items: [
      {
        desktopImage: '/images/dwebgrowth1.jpg',
        itemName: 'Parenting growth 1',
        itemSize: 'LARGE',
        itemType: 'BANNER',
        headingAlignment: 'TOP',
        itemId: 1323,
        mobileWebImage: '/images/mwebgrowth1.jpg',
        viewType: 'HORIZONTAL',
        deeplinkValue: null,
      },
      {
        desktopImage: '/images/dwebgrowth2.jpg',
        itemName: 'Parenting Growth 2',
        itemSize: 'LARGE',
        itemType: 'BANNER',
        headingAlignment: 'TOP',
        itemId: 1323,
        mobileWebImage: '/images/mwebgrowth2.jpg',
        viewType: 'HORIZONTAL',
        deeplinkValue: branch.myloclothdiapers,
      },
      {
        desktopImage: '/images/dwebgrowth3.jpg',
        itemName: 'Parenting Growth 3',
        itemSize: 'LARGE',
        itemType: 'BANNER',
        headingAlignment: 'TOP',
        itemId: 1323,
        mobileWebImage: '/images/mwebgrowth3.jpg',
        viewType: 'HORIZONTAL',
        deeplinkValue: branch.myloclothdiapers,
      },
    ],
  },
];

export const addPriceDetail = [
  {
    useGullackPoints: false,
    orderMrpTotal: 2297,
    orderPriceTotal: 1548,
    orderDeliveryTotal: 0,
    orderDeliveryDiscountTotal: 0,
    orderFinalPriceTotal: 1548,
    orderMaxUsableCoinsOriginal: 0,
    orderUsableCoins: 0,
    orderUsableCoinsValue: 0,
    orderOfferDiscount: 0,
    baseDiscount: 0,
    coinDiscount: 0,
    baseDiscountPercent: 0,
    coinDiscountPercent: 0,
    stopGullackPoints: true,
    orderMrpDiscount: 749,
    orderItemTotal: 1548,
    deliveryFreeUsingCoin: false,
    freeDeliveryApplicable: false,
    sufficientCoinForDelivery: false,
    setDeliveryCoins: 1000,
    freeDeliveryGroup: false,
    freeDeliveryPrice: 0,
    orderWinningCoins: 2297,
    prepaidOrderDiscount: 0,
    offerUserType: '1',
  },
];

export const milkBankToolBanner = {
  items: [
    {
      desktopImage: images.milkbankDweb,
      mobileWebImage: images.milkbankMweb,
    },
  ],
};

export const milkBankData = [
  {
    id: 1,
    name: 'Divya Mother Milk Bank',
    city: 'Udaipur, Rajasthan',
    img: images.divyaBank,
    address:
      'HMQV+J9R, R.N.T Medical College, Panna Dhai Rajkiya Mahila Chikitsalaya, Udaipur, 313001',
    desc: "Divya Mother Milk Bank is the First Mother's Milk Bank of Rajasthan and North India. Divya Mothers Milk Bank is an NGO Organization which operates under an esteemed NGO “Maa Bhagwati Vikas Sansthan” and it aims to provide screened, processed and pasteurized Mother’s Milk to protect, promote and support the infants and babies in needs. It was established in year 2014.",
    contact: '+91 94140 88892',
    state: 'Rajasthan',
    webLink: '',
  },
  {
    id: 2,
    name: 'Lokamanya Tilak Hospital (Sion Hospital)',
    city: 'Sion, Mumbai',
    img: images.LTMGH_vJqhtleu03,
    address:
      'RB2 Central Railway Quarters, Sion West, Sion, Mumbai, Maharashtra 400022',
    desc: 'Started in 1989, the milk bank at Lokmanya Tilak Municipal General Hospital, popularly known as Sion Hospital, is Asia’s first and largest Milk bank.',
    contact: '022-24063154',
    state: 'Mumbai',
    webLink:
      'http://www.ltmgh.com/frontview/inner.aspx?Mkey=MTA5NQ==&lKey=NA==',
  },
  {
    id: 3,
    name: 'Vijaya Hospital',
    city: 'Chennai',
    img: images.vijaya_hospital,
    address: 'No:434, NSK Salai Rd, Vadapalani, Chennai, Tamil Nadu 600026',
    desc: 'Vijaya Human Milk Bank is the First private milk bank in Chennai. Their human milk bank collects and pasteurizes mothers’ milk using state-of-the-art equipment, which is then stored for later use. They provide this milk to preterm and sick infants in need.',
    contact: '044 – 6664 6600',
    state: 'Chennai',
    webLink: 'https://vijayahospital.org/mothers-milk-bank/',
  },
  {
    id: 4,
    name: 'Amaara Milk Bank',
    city: 'Greater Kailash, New Delhi',
    img: images.amaara,
    address: 'S-549, Greater Kailash-II, New Delhi - 110048',
    desc: 'Founded in 2016 Amaara Milk Bank is a non-profit organization which strives to improve health outcomes for preemies and ill infants, fostering better health for children ensuring a safe initiation for the little ones into their respective worlds. They aim to improve health of preemies and ill infants through donated Mother’s Milk. This will consecutively control the Infant Mortality Rate (IMR) throughout the Nation and help to eradicate malnourishment among children in India.',
    contact: '+91-99990 35600',
    state: 'New Delhi',
    webLink: 'https://amaara.org.in/',
  },
  {
    id: 5,
    name: 'Amaara Milk Bank',
    city: 'Richmond Town, Bengaluru',
    img: images.amaara,
    address:
      'No:62, Richmond Road, Mother Teresa Rd, behind Sacred Heart Church Entry from, Xavier Layout, Richmond Town, Bengaluru, Karnataka 560025',
    desc: 'Founded in 2016 Amaara Milk Bank is a non-profit organization which strives to improve health outcomes for preemies and ill infants, fostering better health for children ensuring a safe initiation for the little ones into their respective worlds. They aim to improve health of preemies and ill infants through donated Mother’s Milk. This will consecutively control the Infant Mortality Rate (IMR) throughout the Nation and help to eradicate malnourishment among children in India.',
    contact: '+91-99990 35600',
    state: 'Bengaluru',
    webLink: 'https://amaara.org.in/',
  },
  {
    id: 6,
    name: 'P.G. Hospital (SSKM Hospital)',
    city: 'Kolkata',
    img: images.sskm_tz01eV6VXm,
    address: 'SSKM Hospital Rd, Bhowanipore, Kolkata, West Bengal 700020',
    desc: 'Milk Bank at PG Hospital Kolkata is the first public sector milk bank in the northeastern part of India. As a part of combating covid-19, SSKM introduced an automatic water-free human milk pasteuriser.',
    contact: '033 2204 1100',
    state: 'Kolkata',
    webLink: 'https://ipgmer.gov.in/',
  },
  {
    id: 7,
    name: 'Vani Vilas Women and Children Hospital',
    city: 'Bangalore, Karnataka',
    img: images.vani_vilas_yqmphPIF2n,
    address:
      'Victoria Hospital Compound, Sultan Rd, Kalasipalya, Bengaluru, Karnataka 560002',
    desc: 'Vani Vilas Hospital opened the first state-run human breastmilk bank in Karnataka. Vani Vilas has an average of 70 babies in neonatal ICU every day, whom this milk bank benefits.',
    contact: '098869 31261',
    state: 'Bengaluru',
    webLink: 'https://vvhbmcri.karnataka.gov.in/english',
  },
  {
    id: 8,
    name: "Vatsalya-Maatri Amrit Kosh' (National Human Milk Bank)",
    city: 'Connaught Place, New Delhi',
    img: images.image__11__OnwkurtG1,
    address:
      'Shaheed Bhagat Singh Marg, Lady Hardinge Medical College, DIZ Area, Connaught Place, New Delhi, Delhi 110001',
    desc: 'Vatsalya – Maatri Amrit Kosh” opened at Lady Hardinge Medical College in collaboration with the Norwegian government, Oslo University and NIPI Newborn Project, is a national human milk bank and lactation counseling centre that will collect, pasteurize, test and safely store milk that has been donated by lactating mothers and make it available for infants in need.',
    contact: '011-2336 3728',
    state: 'New Delhi',
    webLink: 'http://lhmc-hosp.gov.in/',
  },
  {
    id: 9,
    name: 'Kanchi Kamakoti Childs Trust Hospital',
    city: 'Nungambakkam, Chennai',
    img: images.kanchi,
    address:
      '12 A, Nageswara Rd, Tirumurthy Nagar, Nungambakkam, Chennai, Tamil Nadu 600034',
    desc: 'KKCTH is the third hospital to get the breast milk bank in Chennai, after the Institute of Child Health and Hospital (ICH) and Vijaya Hospital. Established in 2015.',
    contact: '044-4200 1800',
    state: 'Chennai',
    webLink: 'https://www.kkcth.org/',
  },
  {
    id: 10,
    name: 'Arpan Newborn Care Centre',
    city: 'Ahmedabad',
    img: images.arpan,
    address:
      'Behind Rajpath Club,Opp. Astral Pipes Corporate Office,Ahmedabad, Gujarat – 380054',
    desc: 'A not-for-profit initiative to ensure that sick preterm babies get the ideal nutrition from human breast milk instead of formula feeds at Arpan.',
    contact: '079-4848 1212, 4847 1212',
    state: 'Ahmedabad',
    webLink: 'http://arpannewborncare.com/',
  },
  {
    id: 11,
    name: 'Deenanath Mangeshkar Hospital and Research Centre',
    city: 'Pune',
    img: images.dinanath,
    address:
      'Deenanath Mangeshkar Hospital Road, near Mhatre Bridge, Vakil Nagar, Erandwane, Pune, Maharashtra 411004',
    desc: 'The Milk Bank was established in the year 2011 to improve health outcomes of premature and ill infants, foster better health for children and decrease health care expenditures. The Milk Bank receives human milk from screened donors. It is pasteurized, freezed and distributed to the needy newborns Premature and ill infants in hospital neonatal intensive care unit are our highest priority',
    contact: ' 020 - 49153356',
    state: 'Pune',
    webLink: 'https://www.dmhospital.org/specialty-details/LACTATION-(OBGYN',
  },
  {
    id: 12,
    name: 'Institute of Child Health (ICH) and Hospital for Children',
    city: 'Egmore, Chennai',
    img: images.chennai,
    address: 'Bhanumati, Rina Mandal Rd, Egmore, Chennai, Tamil Nadu 600008',
    desc: "Started in 2014, Milk Bank of ICH is Tamilnadu's first Milk Bank.",
    contact: ' 044-2819 2138',
    state: 'Chennai',
    webLink: '',
  },
];
